define('src/event-aggregator',[
    // Libs
    'underscore',
    'backbone',
    'mustache',
    'utils',
], function(_, Backbone, Mustache, U) {

    var EventAggregator = function(options) {
        this.funnel = {};


        this.initialize.apply(this, arguments);
    };

    _.extend(EventAggregator.prototype, Backbone.Events, {

        initialize: _.noop,

        /**
         * listen to space-separated list of event and triggers a corresponding
         * single event, like bubbling.
         * @type {Object} "my:event another:event" : "funneled:to:this:event"
         */
        applyFunneledEvents: function() {
            this.stopListeningTo(this);
            _.each(this.funnel, function(to, fromEvents) {
                this.funnelEventFrom(this, fromEvents, to);
            }, this);
        }
    });

    EventAggregator.extend = Backbone.Router.extend;

    return EventAggregator;

});

